import {TranslationEntity} from "../../components"

export class SupplierRoundListModel {

  requestRoundStatusName?: string;

  requestRoundId: number;

  requestId: number;

  requestName?: string;

  deadlineForCompletion?: Date;

  deadlineForEvaluation?: number;

  requestRoundStatusUniqueIdentifier?: string;

  requestSupplierDeadline?: Date;

  requestDeadline?: Date;

  requestRoundSupplierStatus?: string;

  requestRoundSupplierStatusUniqueIdentifier?: string;

  requestRoundSupplierId: number;

  isAuction: boolean;

  procurementModelUniqueIdentifier: string;

// custom-start
  translationName: TranslationEntity;

  auctionStartDate: Date;

  auctionDuration: number;

  isAuctionStarted?: boolean | null;

// custom-end

  constructor() {
  }
}

export class SupplierRoundSelectedOffer {
  ticketItemName: string;
  ticketItemStatusName: string;
  contractNumber: string;
  contractValue: number;
}
